/** @jsx jsx */
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import React, { Fragment, useState } from 'react'
import useRootStore from '@store/useRootStore'
import { Radio } from 'antd'
import { showToast, TOAST_TYPE } from '@utils/utils'
import {
  LimitPriceRadio,
  LossLimitWrap, PopupButton,
} from '@views/Popup/LossLimitSettingPopup/index.style'
import { GmoneyIco } from '@shared/Icon/MoneyIcon'
import { Button } from '@styles/button.style'
import { GlobalStoreKey } from '@v2/constants/common'

export interface LossLimitSettingPopupProps {
  onComplete?: () => void
}

const LossLimitSettingPopup: React.FC<LossLimitSettingPopupProps> = ({ onComplete }) => {
  const { globalStore, componentStore } = useRootStore()
  const [checkedPrice, setCheckedPrice] = useState(0)

  const onCheckPrice = (e) => {
    const checkedPrice = e.target.value
    setCheckedPrice(checkedPrice)
  }

  const onSetLimitPrice = () => {
    showToast(TOAST_TYPE.INFO, '손실한도 변경을 완료했습니다.')
    componentStore.setLossLimitAmount(checkedPrice)
    componentStore.saveLossLimitAmount().catch(console.error)
    globalStore.closeGeneralPopup()
    onComplete?.()
  }

  const setting = JSON.parse(globalStore.findGlobalSetting(GlobalStoreKey.REQUIRED_LOSS_LIMIT_SETTING_POPUP).value)
  const limitOptions = setting.limitOptions
  const defaultLimit = limitOptions.length ? limitOptions[limitOptions.length - 1] : 0

  React.useEffect(() => {
    setCheckedPrice(defaultLimit)
  }, [defaultLimit])

  return (
    <Fragment>
      <LossLimitWrap>
        <h1 className="limit-price--title">&#91;1일 손실한도&#93;</h1>
        <p className="limit-price--description">설정한 1일 손실한도 초과 시,<br/>6시간 동안 게임 이용이 제한됩니다.</p>
        <Radio.Group name="limit-price" defaultValue={defaultLimit} value={checkedPrice} onChange={onCheckPrice}
                     css={LimitPriceRadio}>
          {limitOptions.map((price) => (
            <Radio key={price} value={price} className="limit-price-radio--button">
              <div className="limit-price-radio--button--label">
                    <span className="limit-price-radio--button--text">
                      {price.toLocaleString()}
                    </span>
                <i className="gmoney-icon">
                  <GmoneyIco/>
                </i>
              </div>
            </Radio>
          ))}
        </Radio.Group>
      </LossLimitWrap>

      <Button primary css={PopupButton} onClick={onSetLimitPrice}>설정</Button>
    </Fragment>
  )
}

export default observer(LossLimitSettingPopup)
